export default __webpack_public_path__ + "static/media/E_sound.0a9f6813.mp3";